// @flow

import type { PollId } from '../types'

import { call, put, takeEvery } from 'redux-saga/effects'

import { BadResponseError, UnauthorizedError } from '../helpers'

import { sagaPatch } from '../fetch'
import { apiUrlV2ForPollWhereId } from '../urls'

import {
  SET_POLL_FEATURED_FLAG,
  setPollFeaturedFlagSuccess,
  setPollFeaturedFlagError,
} from '../stores/pollsStore'

import { sagaLogoutUnauthorizedUser } from './logout'

export function* setFeaturePollSaga(): Generator<*, *, *> {
  return yield takeEvery(SET_POLL_FEATURED_FLAG, function* featurePoll(action: {
    type: string,
    pollId: PollId,
    featured: boolean,
  }) {
    const { pollId, featured } = action
    const url = apiUrlV2ForPollWhereId(pollId)
    const data = JSON.stringify({
      featured: featured,
    })

    try {
      const response = yield call(sagaPatch, url, data, {
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
      if (response.status === 401 || response.status === 403) {
        yield call(sagaLogoutUnauthorizedUser)
        throw new UnauthorizedError()
      }
      if (response.status === 404) return
      if (response.status !== 200) throw new BadResponseError(response)
      yield put(setPollFeaturedFlagSuccess(pollId, featured))
    } catch (error) {
      yield put(setPollFeaturedFlagError(pollId, featured))
    }
  })
}



// WEBPACK FOOTER //
// ./src/sagas/featurePoll.js